/**
 * Утилиты для работы с датами
 */

/**
 * Форматирует дату в формат yyyy-mm-dd hh:mm:ss
 * @param date - строка даты в формате ISO или объект Date
 * @returns отформатированная строка даты
 */
export function formatDateTime(date: string | Date): string {
  if (!date) return '';

  const d = typeof date === 'string' ? new Date(date) : date;

  // Проверка на валидность даты
  if (isNaN(d.getTime())) return '';

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  const seconds = String(d.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

/**
 * Форматирует дату в формат yyyy-mm-dd (только дата без времени)
 * @param date - строка даты в формате ISO или объект Date
 * @returns отформатированная строка даты
 */
export function formatDate(date: string | Date): string {
  if (!date) return '';

  const d = typeof date === 'string' ? new Date(date) : date;

  // Проверка на валидность даты
  if (isNaN(d.getTime())) return '';

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}
